function udpateHeaderWishlistIcon(list) {
  const wishlistElement = document.querySelectorAll(
    ".header__icon--wishlist"
  );
  const count = list && list.cnt ? list.cnt : 0;
  if (count > 0) {
    wishlistElement.forEach(item => {
     item.classList.add("filled");
    }) 
  } else {
    wishlistElement.forEach(item => {
        item.classList.remove("filled");
    }) 
  }
}

function updateWishlistFunction() {
  let onSuccess = function (lists) {
    if(lists){
        udpateHeaderWishlistIcon(lists[0]);
    }
  };
  window._swat.fetchLists({
    callbackFn: onSuccess,
  });
}

//Add To wishlist Button grab
window.wishlistHandler = {
  attach: function () {
    const wishlistButtons = document.querySelectorAll(
      ".swym-add-to-wishlist, .swym-custom, .swym-add-to-wishlist-view-product"
    );
    if (wishlistButtons) {
      wishlistButtons.forEach((button) => {
        // Save the reference to the event listener
        const eventHandler = function () {
          setTimeout(() => {
            updateWishlistFunction();
          }, 300);
        };

        // Attach the event listener
        button.addEventListener("click", eventHandler);
      });
    }
  },
};

document.addEventListener("DOMContentLoaded", (event) => {
  let intervalId = setInterval(() => {
    if (window._swat && typeof window._swat.fetchLists === "function") {
      clearInterval(intervalId);
      updateWishlistFunction();
      window.wishlistHandler.attach();
    }
  }, 300);
});
